import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';

import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';
import { DOCUMENT_PATTERN_MODALS } from '../../document-import-patterns.constants';
import { IDocumentPatternTableRowProps } from './document-import-patterns-table.interfaces';

const DocumentImportPatternsTableRowActions = ({
  record,
  handleModals,
  t,
}: IDocumentPatternTableRowProps) => {
  const { canDelete, canEdit } = useUserCanManageDocument({
    createdBy: record.createdBy,
    platformPermission: PLATFORM_PERMISSIONS.documentImporter,
  });


  return (
    <Popover
      elements={[
        {
          label: t('common:buttons.edit'),
          icon: ICONS.editAlt,
          key: ICONS.editAlt,
          ...((!canEdit) && { color: PLATFORM_THEME_COLORS.grayVariations.murky }),
          handler: () => {
            if (canEdit) {
              handleModals(DOCUMENT_PATTERN_MODALS.edit, record);
            }
          },
        },
        {
          label: t('common:buttons.delete'),
          icon: ICONS.trash,
          color: canDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,
          key: ICONS.trash,
          handler: () => {
            if (canDelete) {
              handleModals(DOCUMENT_PATTERN_MODALS.delete, record);
            }
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default DocumentImportPatternsTableRowActions;
